export const CarsDropDownMixin = {  
  data: function () {     
    return { 
          dropDownDetails: {
            currencyDetails:   [],
            showCurrencyDetails:false,
            carBrandDetails:   [],
            showCarBrandDetails:false,
            carModelDetails:   [],        
            showCarModelDetails:false,
            carExteriorColors: [],
            showCarExteriorColors:false,
            carInteriorColors: [],
            showCarInteriorColors:false,
            carFuelTypes:      [],
            showCarFuelTypes:false,
            carTransmissions:  [],                    
            showCarTransmissions:false,
            carTypeDetails:    [],
            showCarTypeDetails:false,
            carTractionDetails:[],
            showCarTractionDetails:false,
        },
    }
  },
  methods: {
        getCarBrandDetails: function() {             
            this.$http.get('api/carbrands/maxresult/200').then(response => {                        
                this.dropDownDetails.carBrandDetails = response.body;
                this.dropDownDetails.carBrandDetails.unshift({id:0,name:'Selecionar',"priority": 1,"active": 1});      
                this.dropDownDetails.showCarBrandDetails = true;
            }, response => {            
                eventBus.$emit('errorMsg',response);
            });
        },    
        getCarModelDetails: function() {             
            this.$http.get('api/carmodels/maxresult/10000').then(response => {                        
                this.dropDownDetails.carModelDetails = response.body;
                this.dropDownDetails.carModelDetails.unshift({id:0,name:'Selecionar',"priority": 1,"active": 1});            
                this.dropDownDetails.showCarModelDetails = true;
            }, response => {            
                eventBus.$emit('errorMsg',response);
            });
        },  
        getTractionType: function() {             
            this.$http.get('api/cartraction/maxresult/200').then(response => {                                    
                this.dropDownDetails.carTractionDetails = response.body; 
                this.dropDownDetails.showCarTractionDetails = true;                   
            }, response => {            
                eventBus.$emit('errorMsg',response);
            });
        },           
        getCarColors: function() {             
            this.$http.get('api/carcolor/maxresult/200').then(response => {                                    
                this.dropDownDetails.carExteriorColors = response.body;
                this.dropDownDetails.carInteriorColors = response.body;
                this.dropDownDetails.carExteriorColors.unshift({id:0,name:'Selecionar',"priority": 1,"active": 1});                                                                 
                this.dropDownDetails.showCarExteriorColors = true;
                this.dropDownDetails.showCarInteriorColors = true;
            }, response => {            
                eventBus.$emit('errorMsg',response);
            });
        },     
        getFuelType: function() {             
            this.$http.get('api/carfueltype/maxresult/200').then(response => {                                    
                this.dropDownDetails.carFuelTypes = response.body;              
                this.dropDownDetails.carFuelTypes.unshift({id:0,name:'Selecionar',"priority": 1,"active": 1});            
                this.dropDownDetails.showCarFuelTypes = true;
            }, response => {            
                eventBus.$emit('errorMsg',response);
            });
        },     
        getTransmissionsType: function() {             
            this.$http.get('api/cartransmissiontype/maxresult/200').then(response => {                                    
                this.dropDownDetails.carTransmissions = response.body;              
                this.dropDownDetails.carTransmissions.unshift({id:0,name:'Selecionar',"priority": 1,"active": 1});            
                this.dropDownDetails.showCarTransmissions = true;
            }, response => {            
                eventBus.$emit('errorMsg',response);
            });
        },   
        getCurrency: function() {             
            this.$http.get('api/currency/maxresult/200').then(response => {                                    
                this.dropDownDetails.currencyDetails = response.body;              
                this.dropDownDetails.currencyDetails.unshift({id:0,name:'Selecionar',"priority": 1,"active": 1}); 
                this.dropDownDetails.showCurrencyDetails = true;           
            }, response => {            
                eventBus.$emit('errorMsg',response);
            });
        },     
        getCarType: function() {             
            this.$http.get('api/cartype/maxresult/200').then(response => {                                    
                this.dropDownDetails.carTypeDetails = response.body;              
                this.dropDownDetails.carTypeDetails.unshift({id:0,name:'Selecionar',"priority": 1,"active": 1});            
                this.dropDownDetails.showCarTypeDetails = true;
            }, response => {            
                eventBus.$emit('errorMsg',response);
            });
        },  
  }
};


// WEBPACK FOOTER //
// ./src/components/mixin/CarsDropDownMixin.js